import { render, staticRenderFns } from "./VerticalNavbarDropNft.vue?vue&type=template&id=31e82d60&scoped=true&"
import script from "./VerticalNavbarDropNft.vue?vue&type=script&lang=js&"
export * from "./VerticalNavbarDropNft.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavbarDropNft.vue?vue&type=style&index=0&id=31e82d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e82d60",
  null
  
)

export default component.exports